module.exports = __webpack_public_path__ + "img/guest_meals_online.a6ecce92.png";